import React, { useEffect, useState } from 'react'
import TestingAndCommissioningLayout from '../TestingAndCommissioningLayout';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import { useFormik } from 'formik';
import { useLocation, useParams } from 'react-router-dom';
import MobileScheduleIndex from '../../../Mobile/TestingAndCommisionning/Schedules/MobileScheduleIndex';
import * as yup from 'yup';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { GetAccess } from '../../../../Components/Utils/roles';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import MultiEditSchedule from './MultiEditSchedule';
import ImportSchedule from './ImportSchedule';
import { NuDate } from '../../../../Components/Utils/Input';
import axiosInstance from '../../../../Services/axiosCommon';
import CloseIcon from '../../../../Components/Icons/Close';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';




function SchedulesTestingIndex() {
  const { officeId } = useParams();
  const [showFilterDialog, setShowFilterDialog] = useState(false);

  const { value: Status, getData: refStatus } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Status_Schedules",showFilterDialog
  );

  const [screenSize, setScreenSize] = useState({
         width: window.innerWidth,
       });
     
       useEffect(() => {
         const handleResize = () => {
           setScreenSize({
             width: window.innerWidth,
           });
         };
     
         window.addEventListener("resize", handleResize);
     
         return () => {
           window.removeEventListener("resize", handleResize);
         };
       }, []);

 const location = useLocation();
 const currentPage= location.state?.currentPage
 const searchQuery= location.state?.searchQuery
 const [page, setPage] = useState(currentPage||1)
 const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
 const state = location.state;
 const [filter, setFilter] = useState(
   state?.approvalStatus || state?.category ? true : false
 );
   const [filterProps, setFilterProps] = useState({
 
     status:"",
     startDateFrom:"",
     startDateTo:"",
     endDateFrom:"",
     endDateTo:"",
   });
 const [params, setParams] = useState({
   page: page,
   per_page: pageCount,
   search:searchQuery||"",

   status:"",
     startDateFrom:"",
     startDateTo:"",
     endDateFrom:"",
     endDateTo:"",
     status:state?.status? state.status :"",
  //  category:state?.category? state.category :"",
 });

 const clearFilter = ()=> {
   setParams({...params,status:"", startDateFrom:"", startDateTo:"",endDateFrom:"", endDateTo:"",})
   formik.values.status=""
   formik.values.startDateFrom=""
   formik.values.startDateTo=""
   formik.values.endDateFrom=""
   formik.values.endDateTo=""
  //  formik.values.approvalStatus=""
  //  formik.values.category=""



     setFilter(false)
 }

 const formik = useFormik({
   enableReinitialize: true,
   initialValues: filterProps,
   validateOnChange: false,
   validateOnBlur: false,
   validationSchema: yup.object({
     // email: yup.string().required('Email is required!'),
   }),
   onSubmit: async (value, { resetForm }) => {
     setParams({...params,status:value.status, startDateFrom:value.startDateFrom, startDateTo:value.startDateTo, endDateFrom:value.endDateFrom, endDateTo:value.endDateTo,})
     closeFilterDialog();
     setFilter(true)
     setFilterProps({
      status:"",
      startDateFrom:"",
      startDateTo:"",
      endDateFrom:"",
      endDateTo:"",
     });
   }
 })

 const { data, totalCount, getData,dataLoading } = UseGetDataSearch( `/tc-schedules/listing`,params);

 const defaultHeader = [
   {
     title: "Ref",
     width: "10%",
     isLink: true,
     id: "id",
     link: `/testingAndcommisioning/schedules/view/`,
     field: "refNumber",
     textAlign: "center",
     rowAlign: "center",
   },
   {
    title: "Project Name",
    width: "15%",
    isLink: true,
    id: "id",
    link: `/testingAndcommisioning/schedules/view/`,
    field: "projectName",
    textAlign: "center",
    rowAlign: "center",
  },
  {
    title: "Client",
    width: "15%",
      
    id: "id",

    field: "clientName",
    textAlign: "center",
    rowAlign: "center",
  },
   {
     title: "Type",
     width: "15%",
   
     field: "type",
     textAlign: "center",
     rowAlign: "center",
   },
   
   
   {
     title: "Main Contractor",
     width: "15%",
     field: "mainContractorName",
     textAlign: "center",
     rowAlign: "center",
   },
   {
     title: "Consultant",
     width: "15%",
     field: "consultantName",
     textAlign: "center",
     rowAlign: "center",
   },
   // {
   //   title: "Salesman",
   //   width: "10%",
   //   field: "salesPersonName",
   //   textAlign: "center",
   //   rowAlign: "center",
   // },
   {
     title: "Status",
     width: "10%",
     field: "status",
     textAlign: "center",
     rowAlign: "center",
   },
   {
     title: "Action",
     width: "10%",
     field: "action",
     textAlign: "center",
     rowAlign: "center",
     contents:{
       // fetcher:getData,
       id:"id",
       removeValue:"refNumber",
       url:`/tc-schedules/`,
       moduleName:"Schedule",
       from:`/testingAndcommisioning/schedules`,
       editLink:`/testingAndcommisioning/schedules/edit/`,
       viewLink:`/testingAndcommisioning/schedules/view/`

     }
   },
 ];
 const availableHeaders = [
 
 ];

 const [showExport, setShowExport] = useState(false);
 const [exportValue, setExportValue] = useState({
  status:"",
  startDateFrom:"",
  startDateTo:"",
  endDateFrom:"",
  endDateTo:"",
 });
 const ExportFormik = useFormik({
   enableReinitialize: true,
   initialValues: exportValue,
   validateOnChange: false,
   validateOnBlur: false,
   onSubmit: async (value, { resetForm }) => {
     try {
       const response = await axiosInstance.get(
         `/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`,
         {
           responseType: "blob",
         }
       );

       const pdfBlob = new Blob([response.data], {
         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
       });

       const link = document.createElement("a");
       link.href = window.URL.createObjectURL(pdfBlob);
       link.download = `Schedules Report ${NuDate({
         value: new Date(),
         format: "DD-MMM-YYYY",
       })}.xlsx`;

       document.body.appendChild(link);
       link.click();

       link.parentNode.removeChild(link);
     } catch (error) {
       console.error("Error downloading the PDF:", error);
     }
   },
 });
 const closeFilterDialogebox = () => {
   setShowExport(false);
 };

 const [showEdit, setShowEdit] = useState(false)
 const [showDelete, setShowDelete] = useState(false)
 const [listofNumbers, setListofNumbers] = useState([])
 const [fullList, setFullList] = useState([])

 const selectOneFunction = (value) =>{ 
   let NewId;
   if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
     NewId = listofNumbers.filter(Temp=> Temp !== value);
     setListofNumbers(NewId)
   }else{
     setListofNumbers([...listofNumbers,value])
   }
 }

 const selectMultipleFunction = (e) =>{ 

   if(e.target.checked){
    console.log("if List", fullList);

     setListofNumbers(fullList)
   }else{
    console.log("else List", fullList);

     setListofNumbers([])
   }
   

     }

     useEffect(()=>{
       setParams({...params,page:page,per_page:pageCount})
      },[page,pageCount])
   

     const closeFilterDialog = () => {
       setShowFilterDialog(false);
     };
 const [showImportModal, setShowImportModal] = useState(false);


 const handleImportClick = () => {
   setShowImportModal(true);
 };

 const closeModal = () => {
   setShowImportModal(false);
 };

 useEffect(()=>{
   let tempArr = []
   data && data.forEach(i=>{
    
     tempArr.push(i?.id)
   });
   setFullList(tempArr)
 },[data])

 const [valueOfSearch,setValuesofSearch] = useState("")
  function searchFunction(e) {

    
    setValuesofSearch(e?.target?.value)
    setParams({ ...params, search: e?.target?.value, page:1 });
    setPage(1)
  }



 return (
   <>
   <TestingAndCommissioningLayout 
     setOpen={setShowImportModal}
     searchFun={searchFunction}
     searchValue={valueOfSearch}

     // getData={getData}
     isFilter={filter}
     neededSearch={true}
     newfilter={true}
 officeId={officeId}

     setFilterOpen={setShowFilterDialog}
     ClearFilter={clearFilter}
     CreateAccess={GetAccess("testing_and_commisioning_module")}
     ImportAccess={GetAccess("testing_and_commisioning_module")}
           ExportAccess={GetAccess("testing_and_commisioning_module")}
           setOpenExport={setShowExport}
     
     // officeId={officeId}
     // projectID={projectID}
       >


        
{
 screenSize.width <= "786" ?(<>
 <div className=' w-full h-[calc(100vh-160px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
 <MobileScheduleIndex
 data={data}
 total={totalCount}
 pageIndex={page}
 setPageIndex={setPage}
 dataCount={pageCount}
 setDataCount={setPageCount}
 officeId={officeId}
 getData={getData}

 />
 </div>
 </>):(<>


   <div className='w-full h-full  '>
     {/* <div className='w-full flex justify-between items-center'>
       <Breadcrumb
         items={[
           { name: "Procurement" },
           { name: "YPR" },
         ]} />
       <div className=' flex gap-2'>
       <SearchBar
             handleChange={(e) =>{
               setParams({ ...params, search: e.target.value, page:1 });
               setPage(1)
             }}
             value={params.search||searchQuery}
           />  <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
         {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>} */}
       
         {/* {GetAccess("purchase_request_create") && <ImportButton handleClick={handleImportClick} />} */}
         {/* {GetAccess("purchase_request_create") && <Link to={`/main/${officeId}/procurement/purchase-requests/create`}><CreateButton label='YPR' /></Link>}
       </div>
     </div> */}

     <CustomDataTable 
     fetcher={getData}
       data={data} 
       availableHeaders={availableHeaders} 
       defaultHeader={defaultHeader}
       bodyHeight='max-h-[calc(100vh-260px)]'
       height='h-[calc(100vh-160px)]'
       total={totalCount}
       pageIndex={page}
       setPageIndex={setPage}
       dataCount={pageCount}
       setDataCount={setPageCount}
       // title='PR List'
       storageName="SchedulesTable"
       selectOneFunction={selectOneFunction}
       setShowDelete={setShowDelete}
       showDelete={showDelete}
       setShowEdit={setShowEdit}
       showEdit={showEdit}
       listofNumbers={listofNumbers} 
       hasMultiEdit={true}
       selectMultipleFunction={selectMultipleFunction}
       fullList={fullList}
       getById="id"
       editAccess="schedule_edit"      
       deteleAccess="schedule_delete" 
       dataLoading={dataLoading}
       searchQuery={params?.search!=""?params?.search:""}
       // dateShow={true}
       />
   </div>

</>)}

 

       </TestingAndCommissioningLayout>

       {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">
             <p className="py-2 px-6 text-m">Start Date</p>
                           <div className="flex justify-between  w-full ">
                            <NuDate
                             label="From "
                             placeholder="dd/mm/yyyy"
                             formik={formik}
                             name="startDateFrom"
                             width="w-full"
                           />
                            <NuDate
                             label="To "
                             placeholder="dd/mm/yyyy"
                             formik={formik}
                             name="startDateTo"
                             width="w-full"
                           />
                           </div>
                           <p className="py-2 px-6 text-m">End Date</p>
                           <div className="flex justify-between  w-full ">
                            <NuDate
                             label="From "
                             placeholder="dd/mm/yyyy"
                             formik={formik}
                             name="endDateFrom"
                             width="w-full"
                           />
                            <NuDate
                             label="To "
                             placeholder="dd/mm/yyyy"
                             formik={formik}
                             name="endDateTo"
                             width="w-full"
                           />
                            </div>
                            <FormikSelectTwo
                          label="Status"
                          Options={Status}
                          formik={formik}
                          placeholder="Choose"
                          name="status"
                          isRequired={true}
            
                          width="w-full"
                          displayProperty={"Status"}
                          propertyName={"Status_Schedules"}
                             getFunc={refStatus}
            
                        />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}

      {showEdit && (
        <MultiEditSchedule
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportSchedule
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}

{showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type =="all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                    <p className="py-2 px-6 text-m">Start Date</p>
                           <div className="flex justify-between  w-full ">
                            <NuDate
                             label="From "
                             placeholder="dd/mm/yyyy"
                             formik={formik}
                             name="startDateFrom"
                             width="w-full"
                           />
                            <NuDate
                             label="To "
                             placeholder="dd/mm/yyyy"
                             formik={formik}
                             name="startDateTo"
                             width="w-full"
                           />
                           </div>
                           <p className="py-2 px-6 text-m">End Date</p>
                           <div className="flex justify-between  w-full ">
                            <NuDate
                             label="From "
                             placeholder="dd/mm/yyyy"
                             formik={formik}
                             name="endDateFrom"
                             width="w-full"
                           />
                            <NuDate
                             label="To "
                             placeholder="dd/mm/yyyy"
                             formik={formik}
                             name="endDateTo"
                             width="w-full"
                           />
                            </div>
                            <FormikSelectTwo
                          label="Status"
                          Options={Status}
                          formik={formik}
                          placeholder="Choose"
                          name="status"
                          isRequired={true}
            
                          width="w-full"
                          displayProperty={"Status"}
                          propertyName={"Status_Schedules"}
                             getFunc={refStatus}
            
                        />

                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

       
   </>
 )
}

export default SchedulesTestingIndex
